export default __webpack_public_path__ + "static/media/icon-comms-dark.9872baf8.svg";